module.exports = __webpack_public_path__ + "img/activeshks.868f3c62.png";